/* Horizontal product rail: arrow controls + edge state.
   Scrolling itself is native (CSS overflow + scroll-snap) so touch, trackpad,
   keyboard and screen readers all work without JS. This only adds the desktop
   arrows and hides them when there is nothing to scroll to. */
(function () {
  var THRESHOLD = 2; // px tolerance for float rounding at the ends

  function init(wrap) {
    if (wrap.dataset.jjvRailReady) return;
    wrap.dataset.jjvRailReady = '1';

    var rail = wrap.querySelector('.jjv-rail');
    var prev = wrap.querySelector('[data-jjv-rail-prev]');
    var next = wrap.querySelector('[data-jjv-rail-next]');
    if (!rail || !prev || !next) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function step() {
      var item = rail.querySelector('.grid__item');
      var w = item ? item.getBoundingClientRect().width : rail.clientWidth / 2;
      var gap = parseFloat(getComputedStyle(rail).columnGap || '0') || 0;
      // move by whole cards, roughly one viewport's worth, never past the edge
      var perView = Math.max(1, Math.floor(rail.clientWidth / (w + gap)));
      return (w + gap) * perView;
    }

    function update() {
      var max = rail.scrollWidth - rail.clientWidth;
      var scrollable = max > THRESHOLD;
      // hidden (not just disabled) when the rail fits — no dead controls
      prev.hidden = !scrollable;
      next.hidden = !scrollable;
      if (!scrollable) return;
      prev.disabled = rail.scrollLeft <= THRESHOLD;
      next.disabled = rail.scrollLeft >= max - THRESHOLD;
    }

    function go(dir) {
      rail.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' });
    }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });

    var ticking = false;
    rail.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { update(); ticking = false; });
    }, { passive: true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(update).observe(rail);
    } else {
      window.addEventListener('resize', update);
    }
    update();
  }

  function boot(root) {
    (root || document).querySelectorAll('[data-jjv-rail]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  // sections re-rendered by the theme editor
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });

  // <product-recommendations> swaps its own innerHTML after an async fetch and
  // fires no event, so watch for rails that appear later.
  if ('MutationObserver' in window) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches('[data-jjv-rail]')) init(n);
          if (n.querySelectorAll) boot(n);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('jjv:rail:refresh', function (e) { boot(e.target || document); });
  window.jjvRailBoot = boot;
})();
